<p class="hvac-address hvac-h6">
    <span *ngIf="name" >{{ name }} <br /></span>
    <span *ngIf="line1" >{{ line1 }} <br /></span>
    <span *ngIf="line2" >{{ line2 }} <br /></span>
    <span *ngIf="line3" >{{ line3 }} <br /></span>
    {{ city }}, {{ state }} {{ zipCode }} <br />
    <span *ngIf="country" >{{ country }}</span>
</p>